import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const module = {
	state: {
		ofertas: {
			empleo: [],
			practicas: []
		},
		programas : ''
	},
	getters: {
		getOfertas : (state) => state.ofertas,
		getProgramas : (state) => state.programas,
	},
	actions: {
		initApp:({dispatch}) => {
			dispatch('requestOfertas');
			dispatch('requestProgramas');
		},
		requestOfertas:({commit}) => {
			return new Promise((resolve, reject) => {
				axios.get('api/Publico/dameUltimasOfertas/empleo').then(result => {
					if(result.data.status == 0){
						commit("setEmpleo", result.data.datos.ofertas);
					}
				}).catch(error => {
					reject(false);
				});
/* 				axios.get('api/Publico/dameUltimasOfertas/practicas').then( result => {
					if(result.data.status == 0){
						commit("setPracticas", result.data.datos.ofertas);
					}
				}).catch(error => {
					reject(false);
				});   */
			});	
		},
		requestProgramas:({commit}) => {
			return new Promise((resolve, reject) => {
				axios.get('api/Publico/programasPracticasActivos').then( result => {
					if(result.data.status == 0){
						commit("setProgramas", result.data.datos);
					}
				}).catch(error => {
					reject(false);
				});  
			});	
		},
		requestPrograma:({commit}, id) => {
			return new Promise((resolve, reject) => {
				axios.get('api/Publico/detallePrograma/'+id).then( result => {
					if(result.data.status == 0){
						resolve(result.data.datos)
					}
				}).catch(error => {
					reject(false);
				});  
			});	
		},
		requestComunicaciones:({},data) => {
			return new Promise((resolve, reject) => {
				// axios.post('api/contacto',data).then( result => {
				// 	(result.data == 1) ? resolve(true) : reject(false);
				// }).catch(error => {
				// 	reject(false);
				// });  
			});	
		},
		sendContacto : ({}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('api/Publico/solicitudContacto',data).then( result => {
					(result.data.status == 0) ? resolve(true) : reject(false);
				}).catch(error => {
					reject(false);
				});  
			});	
		},
	},
	mutations: {
		setProgramas(state,data){
			state.programas = data;
		},
		setPracticas(state,data){	
			if(!!data){
				state.ofertas.practicas = data;
			}
		},
		setEmpleo(state,data){
			if(!!data){
			state.ofertas.empleo = data;
			}
		}
	}
}

export default module;



// WEBPACK FOOTER //
// ./src/store/data.js